module.exports = __webpack_public_path__ + "img/partB2.75f5b3de.png";